import { Report } from '@shared/enums/report.enum';

type EnumDictionary<T extends string | symbol | number, U> = {
  [K in T]: U;
};

export enum FeatureFlag {
  OpportunitySubmission = 'Opportunity__Submission',
  OpportunityESignPAPP = 'Opportunity__ESign__PAPP',
  OpportunityMoneyplaceBorrowCapacity = 'Opportunity__Moneyplace__Borrowing__Capacity',
  ProductMatrix = 'Product_Matrix',
  Kyc = 'KYC',
  ContactDeletion = 'ContactDeletion',
  ContactReassignment = 'ContactReassignment',
  Reports = 'Reports',
  Insurance = 'Insurance',
  Refix = 'Refix',
  CommercialMotor = 'CommercialMotor',
  AliGroupInsurance = 'AliGroupInsurance',
  LnsPanelLenders = 'LnsPanelLenders',
  BridgingFinance = 'BridgingFinance',
  CapitaliseInterest = 'CapitaliseInterest',
  OpportunityPlanner = 'OpportunityPlanner',
  Reverse = 'Reverse',
  ServicingOverride = 'ServicingOverride',
  FactFind = 'FactFind',
  /** Scope + document-request template save/apply/manage on Fact Find surfaces. */
  FactFindTemplates = 'FactFindTemplates',
}

export interface ReportFeatureSettings {
  [Report.Lending]: Record<string, never>;
}

export interface GlassGuideApiConfiguration {
  url: string;
  key: string;
}

export interface GoogleMapsApiConfiguration {
  key: string;
}

export interface RetryConfig {
  maxRetries: number;
  delayMs: number;
}

export interface IEnvironment {
  environment: string;
  production: boolean;

  // analytics
  hotjarId?: number;
  heapAppId?: string;

  // service worker refresh
  useServiceWorkers: boolean;
  serviceWorkersCheckUpdatesMins: number;
  enableServiceWorkerVerboseLogging: boolean;

  // monitoring
  appInsightsConnectionString: string | null;

  // b2c config
  sparkPlusApplicationId: string;
  sparkPlusB2CTenant: string;
  sparkPlusB2CUserFlow: string;
  iqApplicationId: string;
  iqB2CTenant: string;
  iqB2CUserFlow: string;
  iqRedirectUri: string;

  // protected APIs and required scopes/keys
  clientsApiUrl: string;
  clientsApiScopes: Array<string>;
  managementApiUrl: string;
  managementApiScopes: Array<string>;
  opportunityApiUrl: string;
  opportunityApiScopes: Array<string>;
  libraryApiUrl: string;
  libraryApiScopes: Array<string>;
  glassGuideApi: GlassGuideApiConfiguration;
  googleMapsApi: GoogleMapsApiConfiguration;
  iqAuthApiUrl: string;
  iqAuthApiScopes: Array<string>;
  libertyGatewayUrl: string;
  opportunityDocumentApiUrl: string;
  opportunityDocumentApiScopes: Array<string>;

  // external urls
  iqWebUrl: string;

  // flags to enable/disable features
  features: EnumDictionary<FeatureFlag, boolean>;
  // settings for individual features
  settings: {
    [FeatureFlag.Reports]: ReportFeatureSettings;
  };
  // retry configuration
  retryConfig: RetryConfig;

  // mock API interceptor (only enable for local development)
  enableMockApi?: boolean;

}
